export default ($axios) => ({
  fetch(query) {
    return $axios.get('/whatsapp/new/numbers', { params: query }).then((response) => response.data);
  },
});
